import { DataSource } from "@/public/gql/__generated__/graphql"

// 上野クリニック(スプレッドシート)の店舗判定。
// 予約を確定せず希望枠の「受付 (リクエスト)」だけを行う request フローに乗る媒体かどうか。
// nabeko 側は data_source_policy.go の switch で媒体ごとの挙動を集約しているため、
// FE 側の dataSource 文字列比較もここ 1 箇所に集約する (散在させない)。
export const isUenoClinicDataSource = (
	dataSource: DataSource | undefined
): boolean => {
	return dataSource === "UENO_CLINIC_SPREAD_SHEET"
}
